import * as React from 'react';
import allLoops from './loops';

import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import labels from './labels';
import Loop from './Loop';

import Label from './Label';
import { Overlay } from '../components/Overlay';
import MusicGenre from './MusicGenre';
import { LoopOption } from './LoopOption';

const labelsMap = {};
labels.forEach(label => {
  labelsMap[label.id] = label;
});

const genres = {};
const processLoops = () => {
  let genre;
  allLoops.forEach((loop: Loop) => {
    loop.label = labelsMap[loop.labelId!];
    const g = loop.genre!;
    if (genres[g] === undefined) {
      genres[g] = {
        name: g,
        loops: []
      };
    }
    genre = genres[g];
    genre.loops.push(loop);
  });
};
processLoops();

interface Props {
  genre: MusicGenre;
}

interface State {
  hoveredLoop: Loop | null;
  selectedLoop: Loop | null;
}

export default class extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);

    this.state = {
      hoveredLoop: null,
      selectedLoop: null
    };
  }

  onSelectLoop = (loop: Loop) => {
    storeDispatch(Actions.assignLoop(loop));
  };

  didSelectLabel = (label: Label) => {
    storeDispatch(Actions.showLabelDetails(label));
  };

  render() {
    const { genre } = this.props;
    const loops = genres[genre].loops as Loop[];
    return (
      <Overlay fullWidth={true}>
        <a
          className="overlay-back-button"
          onClick={() => {
            storeDispatch(Actions.showGenreSelector());
          }}
        >
          ← Change genre
        </a>
        <h1>{`Select ${genre} track`}</h1>
        <div className="loop-selection-container">
          <div className="loop-options">
            {loops.map((loop, index) => (
              <LoopOption
                loop={loop}
                key={index}
                onSelect={this.onSelectLoop}
                onLabelSelect={this.didSelectLabel}
              />
            ))}
          </div>
          {/* <footer style={{ marginTop: 30 }}>
            Are you a producer? Many clubs and record labels around the world
            are using Beatflyer.
            <br />
            Would you be interested in seeing your tracks here? Please{' '}
            <a href="mailto:info@beatflyer.com">get in touch</a>.
          </footer> */}
        </div>
      </Overlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/audio-editing/LoopSelection.tsx